module.exports = __webpack_public_path__ + "svgs/icon_rights_discount.d8ebfbae.svg";